import api from './api';

export function getAll(params = {}) {
    return api.get('/services', { params });
}

export function getUserServices(userId) {
    return api.get(`/users/${userId}/services`);
}

export function getOne(serviceId) {
    return api.get(`/services/${serviceId}`);
}

export function assignLicence(serviceId, licenceId, licenceType) {

    const config = {
        service_id: serviceId,
        licence_id: licenceId,
        licence_type: licenceType
    };

    return api.post(`service-licences`, config);
}

export function removeLicence(serviceLicenceId) {
    return api.delete(`service-licences/${serviceLicenceId}`);
}